export enum Variant {
  HIGHLIGHT = 'highlight',
  CLASSIC = 'classic',
  INLINE = 'inline',
  IMAGE_ONLY = 'imageOnly',
  ICON_ONLY = 'iconOnly',
  VALUE_ONLY = 'valueOnly',
  OVERVIEW_INLINE = 'overviewInline',
}
